export default "__VITE_ASSET__SZl4tngK__"